import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * A small fact beside a figure (spec 225, moved here by spec 233 R2): an icon and a
 * few words in a quiet pill, with the longer explanation on hover. Spend's Where it
 * went draws "6 not measured" in the neutral tone; the Models tab draws "2 without
 * token counts" in the warning tone. One shape, so the two read as one vocabulary.
 */
export function NoteChip({
  icon: Icon,
  text,
  title,
  tone = 'neutral',
}: {
  icon: LucideIcon;
  text: string;
  title: string;
  tone?: 'neutral' | 'warning';
}) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-1.5 py-px text-xs font-normal not-italic whitespace-nowrap',
        tone === 'warning'
          ? 'border-warning/40 text-warning'
          : 'border-border text-muted-foreground',
      )}
    >
      <Icon className="size-3" strokeWidth={2} aria-hidden="true" />
      {text}
    </span>
  );
}
